import { BankPaymentOption, CardPaymentOption } from '@/interfaces/payment-options';
import api from '~/api/client';
import { CONSUMER_API_PATH } from './config';
import { Response } from '@/interfaces/api';
import { AchProviders } from '@/constants/payments';
import { MoovTokenResponse } from '@/interfaces/moov';

export function getBankAccounts(
  achProvider: AchProviders = AchProviders.Crb,
): Response<BankPaymentOption> {
  if (achProvider === AchProviders.Crb) {
    return api.client.get(`${CONSUMER_API_PATH}/payment-options/ach-bank-accounts/`);
  }

  return api.client.get(`${CONSUMER_API_PATH}/payment-options/bank-accounts/`);
}

export function syncCards(): Response<CardPaymentOption> {
  return api.client.post(`${CONSUMER_API_PATH}/payment-options/cards/`);
}

export function verifyRoutingNumber(
  routingNumber: string
): Response<{ bank_account_name: string }> {
  return api.client.get(`${CONSUMER_API_PATH}/payments/institutions/${routingNumber}/search/`);
}
export function removeBankAccount(uuid: string) {
  return api.client.delete(`${CONSUMER_API_PATH}/payment-options/bank-accounts/${uuid}/`);
}

export function removeCard(uuid: string) {
  return api.client.delete(`${CONSUMER_API_PATH}/payment-options/cards/${uuid}/`);
}

export function getMoovToken(): Response<MoovTokenResponse> {
  return api.client.get(`${CONSUMER_API_PATH}/payment-options/account-data/`);
}
